<template>
    <div>
        <div class="mb-3 row">
            <div class="col-sm-12" v-if="Records.length <= 0">
                <b-button variant="outline-primary" class="btn btn-outline-primary p-l-15 d-flex align-items-center"
                    v-bind:t_label="'EMPBE_ProductInfoCenter_Catalog_btnAddNewWithoutCatalog'" @click="checkLaunchLimit"
                    v-b-toggle="'productRightpopup'">
                    <feather type="plus-circle"></feather>
                    {{ $t("lbl_EMPBE_NotHaveCatalog") }}
                </b-button>
            </div>
        </div>
        <b-overlay :show="loading" rounded="sm" v-if="Records.length > 0">
            <localization :language="kendoLang">
                <intl :locale="kendoLang">
                    <Grid ref="grid" :data-items="gridData" :resizable="true" :reorderable="true" :sortable="true"
                        :pageable="gridPageable" :groupable="false" :group="group" :sort="sort" :filter="filter"
                        :filterable="true" :take="take" :skip="skip" :columns="columns" :column-menu="columnMenu"
                        :selectable="true" :selected-field="selectedField" @headerselectionchange="onHeaderSelectionChange"
                        @datastatechange="dataStateChange" @selectionchange="onSelectionChange">
                        <toolbar>
                            <span class="k-textbox k-grid-search k-display-flex" v-if="false">
                                <b-form-input type="text" :placeholder="$t('lbl_SearchByKeyword')" v-model="searchWord"
                                    @input="onFilter"></b-form-input>
                            </span>
                            <span class="export-buttons">
                                <kbutton :theme-color="'secondary'" @click="checkLaunchLimit"
                                    v-bind:t_label="'EMPBE_ProductInfoCenter_Catalog_btnAddNew'">
                                    <i class="fa fa-plus-circle" style="line-height: 1.5;"></i>
                                    {{ $t("lbl_EMPBE_AddNewCatelog") }}
                                </kbutton>
                                &nbsp;
                                <kbutton :theme-color="'primary'" @click="openOrderingPage" v-if="false"
                                    v-bind:t_label="'EMPBE_ProductInfoCenter_Product_btnOpenOrdering'">
                                    <i class="fa fa-list-ol" style="line-height: 1.5;"></i>
                                    {{ $t("lbl_EMPBE_ChangeOrder") }}
                                </kbutton>
                                &nbsp;
                                <kbutton :theme-color="'primary'" v-b-toggle="'PopupCatalog'"
                                    :disabled="otherInfo ? otherInfo.directory_TotalQty >= 10 : false"
                                    v-bind:t_label="'EMPBE_ProductInfoCenter_Catalog_btnAddToCart'">
                                    <i class="icon-shopping-cart" style="line-height: 1.5;"></i>
                                    {{ $t("lbl_EMPBE_AddActivateIndex") }}
                                    ({{ $t("lbl_EMPBE_Current") }}:{{ otherInfo ? otherInfo.directory_LaunchedCount : 0
                                    }}/{{ otherInfo ? otherInfo.directory_TotalQty : 0 }})
                                </kbutton>
                            </span>
                        </toolbar>
                        <template v-slot:IdTemplate="{ props }">
                            <td v-if="props.rowType !== 'groupHeader'">
                                <router-link class="pl-0 no-router-link-exact-active" v-b-toggle="'productRightpopup'"
                                    :to="'/productInfoCenter/indexDetail/' + props.dataItem.id"
                                    v-bind:t_label="'EMPBE_ProductInfoCenter_Index_' + props.dataItem.id">
                                    {{ props.dataItem.name ? props.dataItem.name : $t('lbl_Newcatalog') }}
                                </router-link>
                            </td>
                        </template>
                        <template v-slot:lastSubmitDateTemplate="{ props }">
                            <td v-if="props.rowType !== 'groupHeader'">
                                <!-- <custom-date :date="props.dataItem.lastSubmitDate"></custom-date> -->
                                {{ props.dataItem.lastSubmitDate }}
                            </td>
                        </template>
                        <template v-slot:lastSaveDateTemplate="{ props }">
                            <td v-if="props.rowType !== 'groupHeader'">
                                <custom-date :date="props.dataItem.lastSaveDate"></custom-date>
                                <span class="badge badge-warning m-r-5 m-l-5 f-16" v-if="false">
                                    <span
                                        v-if="props.dataItem.lastSaveDate > props.dataItem.lastSubmitDate || props.dataItem.lastSubmitDate == undefined">{{
                                            $t('lbl_EMPBE_UnsubmittedDraft') }}</span>
                                </span>
                            </td>
                        </template>
                        <template v-slot:statusDateTemplate="{ props }">
                            <td v-if="props.rowType !== 'groupHeader'">
                                <span v-if="props.dataItem.lastSubmitDate" class="badge-success badge m-r-5 m-l-5 f-16">{{
                                    $t('lbl_EMPBE_isActivate') }}</span>
                                <span v-else class="badge-info badge m-r-5 m-l-5 f-16">
                                    {{ $t('lbl_EMPBE_Draft') }}
                                </span>
                            </td>
                        </template>
                        <!-- <template v-slot:ActivateTemplate="{ props }">
                            <td v-if="props.rowType !== 'groupHeader'">
                                <span v-if="props.dataItem.spanIsLaunch"
                                    class="badge-light-success badge m-r-5 m-l-5 f-16">{{
                                        $t('lbl_EMPBE_isActivate') }}</span>
                                <span v-else class="badge-light badge m-r-5 m-l-5 f-16">
                                    {{ $t('lbl_EMPBE_NotActivate') }}
                                </span>
                            </td>
                        </template> -->
                        <template v-slot:filterSlotTemplate="{ props, methods }">
                            <div>
                                <k-input :placeholder="$t('lbl_EMPBE_SearchByKeyword')" :value="props.value" @input="(ev) => {
                                    props.onChange({
                                        operator: 'contains',
                                        field: props.field,
                                        value: ev.target.value,
                                        syntheticEvent: ev,
                                    });
                                }
                                    " />
                            </div>
                        </template>
                        <template v-slot:DatefilterSlotTemplate="{ props, methods }">
                            <div>
                                <DropDownList :data-items="dateSortingData" :text-field="'text'" :data-item-key="'value'"
                                    :default-item="dateSortingDefault" @change="(ev) => {
                                        if (sort.filter(x => x.field == props.field).length > 0) {
                                            if (ev.value.value == '') {
                                                sort = sort.filter(x => x.field != props.field)
                                            } else {
                                                sort.find(x => x.field == props.field).dir = ev.value.value
                                            }
                                        } else if (ev.value.value != '') {
                                            sort.push({ dir: ev.value.value, field: props.field })
                                        }
                                        gridData = getData(items)
                                    }
                                        " />
                            </div>
                        </template>
                        <template v-slot:DateStatusfilterSlotTemplate="{ props, methods }">
                            <div class="row">
                                <div class="col-6 pr-0">
                                    <DropDownList :data-items="dateSortingData" :text-field="'text'"
                                        :data-item-key="'value'" :default-item="dateSortingDefault" @change="(ev) => {
                                            if (sort.filter(x => x.field == props.field).length > 0) {
                                                if (ev.value.value == '') {
                                                    sort = sort.filter(x => x.field != props.field)
                                                } else {
                                                    sort.find(x => x.field == props.field).dir = ev.value.value
                                                }
                                            } else if (ev.value.value != '') {
                                                sort.push({ dir: ev.value.value, field: props.field })
                                            }
                                            gridData = getData(items)
                                        }
                                            " />
                                </div>
                                <div class="col-6 pl-0">
                                    <DropDownList :data-items="statusSortingData" :text-field="'text'"
                                        :data-item-key="'value'" :default-item="statusSortingDefault" @change="(ev) => {
                                            if (ev.value.value == '') {
                                                props.onChange({ operator: '', field: '', value: '', event: ev });
                                            } else if (ev.value.value > 1) {
                                                props.onChange({
                                                    operator: 'isnotnull',
                                                    field: props.field,
                                                    value: 1,
                                                    syntheticEvent: ev,
                                                });
                                            } else {
                                                props.onChange({
                                                    operator: 'isnull',
                                                    field: props.field,
                                                    value: 1,
                                                    syntheticEvent: ev,
                                                });
                                            }
                                            gridData = getData(items)
                                        }
                                            " />
                                </div>
                            </div>
                        </template>
                        <template v-slot:StatusfilterSlotTemplate="{ props, methods }">
                            <DropDownList :data-items="statusSortingData" :text-field="'text'" :data-item-key="'value'"
                                :default-item="statusSortingDefault" @change="(ev) => {
                                    if (ev.value.value == '') {
                                        props.onChange({ operator: '', field: '', value: '', event: ev });
                                    } else if (ev.value.value > 1) {
                                        props.onChange({
                                            operator: 'isnotnull',
                                            field: props.field,
                                            value: 1,
                                            syntheticEvent: ev,
                                        });
                                    } else {
                                        props.onChange({
                                            operator: 'isnull',
                                            field: props.field,
                                            value: 1,
                                            syntheticEvent: ev,
                                        });
                                    }
                                    gridData = getData(items)
                                }
                                    " />
                        </template>
                    </Grid>
                </intl>
            </localization>
        </b-overlay>
        <visitorPermissionPopup PopupUid="PopupCatalog"></visitorPermissionPopup>
    </div>
</template>

<script>
import { InquiryFormService, productService } from '../../_services'
import visitorPermissionPopup from '@/components/visitorPermissionPopup'

import { Grid, GridToolbar } from '@progress/kendo-vue-grid';
import { Input } from '@progress/kendo-vue-inputs';
import { Button } from '@progress/kendo-vue-buttons';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import { process } from '@progress/kendo-data-query';
import { DateRangePicker } from '@progress/kendo-vue-dateinputs';
import { IntlProvider, load, LocalizationProvider, loadMessages } from '@progress/kendo-vue-intl';
import CustomStartDateInput from '../../components/form/dateRangePicker/customStartDateInput.vue';
import CustomEndDateInput from '../../components/form/dateRangePicker/customEndDateInput.vue';

export default {
    props: ["Records", "otherInfo", "addToCart"],
    components: {
        Grid: Grid,
        toolbar: GridToolbar,
        localization: LocalizationProvider,
        intl: IntlProvider,
        'k-input': Input,
        kbutton: Button,
        visitorPermissionPopup: visitorPermissionPopup,
        DateRangePicker,
        CustomStartDateInput,
        CustomEndDateInput,
        DropDownList
    },
    data() {
        return {
            loading: false,
            error: null,
            totalRows: 1,
            currentPage: 1,
            items: [],
            gridData: [],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            rowSelected: [],
            skip: 0,
            take: 10,
            group: [],
            sort: [],
            filter: {
                logic: 'and',
                filters: [],
            },
            gridPageable: {
                buttonCount: 5,
                info: true,
                type: 'numeric',
                pageSizes: true,
                previousNext: true,
            },
            searchWord: '',
            selectedField: 'selected',
            columnMenu: false,
            dateSortingData: [
                { value: "asc", text: this.$t("lbl_EMP2_Sort_Asc") },
                { value: "desc", text: this.$t("lbl_EMP2_Sort_Dsc") }
            ],
            dateSortingDefault: { value: '', text: this.$t('Lbl_News_SortByDate') },
            statusSortingData: [
                { value: 1, text: this.$t("lbl_EMPBE_Draft") },
                { value: 2, text: this.$t("lbl_EMPBE_isActivate") }
            ],
            statusSortingDefault: { value: '', text: this.$t('lbl_EMPBE_FilterBy') },
        
        };
    },
    created() {
        this.gridData = this.getData(this.items);
    },
    computed: {
        user() {
            return this.$store.state.authentication.user;
        },
        companyid() {
            return this.user.empCompanyId;
        },
        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return { text: f.label, value: f.key };
                });
        },
        selectedDataItems() {
            return this.gridData.data.filter((item) => item.selected === true);
        },
        areAllSelected() {
            return (
                this.selectedDataItems.length === this.gridData.data.length &&
                this.selectedDataItems.length !== 0
            );
        },
        columns() {
            return [

                { field: 'name', title: this.$t("lbl_EMPBE_ProductIndex"), cell: 'IdTemplate', filterCell: 'filterSlotTemplate' },
                { field: 'lastSaveDate', title: this.$t("lbl_EMPBE_LastUpdateDate"), cell: 'lastSaveDateTemplate', filter: 'date', format: '{0:D}', filterCell: 'DatefilterSlotTemplate' },
                { field: 'lastSubmitDate', title: this.$t("lbl_EMPBE_LastSubmitDate"), cell: 'lastSubmitDateTemplate', filter: 'date', format: '{0:D}', filterCell: 'DatefilterSlotTemplate' },
                { field: 'lastSubmitDate', title: this.$t("lbl_buyerform_status"), cell: 'statusDateTemplate', filterCell: 'StatusfilterSlotTemplate', },
                //{ field: 'IsLaunch', title: this.$t("lbl_EMPBE_isActivate"), cell: 'ActivateTemplate', filter: 'boolean' },
                // { field: 'uniqueCode', title: '操作', cell: 'ActionTemplate', filterable: false},


            ];
        },
        kendoLang() {
            var langid = localStorage.getItem("currentLangId");
            switch (langid) {
                case "1252":
                    return "en-US";
                case "950":
                    return "zh-Hant";
                case "936":
                    return "zh-Hans";
                default:
                    return "zh-Hans";
            }
        },
        langid() {
            return localStorage.getItem("currentLangId")
        },
    },
    mounted() {
        // Set the initial number of items
        this.totalRows = this.items.length;
        // this.items = this.Records;
        this.itemsRecordProcess();
        this.totalRows = this.Records.length;
        this.gridData = this.getData(this.items);
    },
    watch: {
        Records() {
            console.log(this.langid)
            //this.items = this.Records;
            // console.log('this.Records')
            // console.log(this.Records)
            // this.Records.forEach(element => {
            //     var data = this.items.filter(c => c.id == element.id);
            //     if (data.length <= 0) {
            //         if (element.langid == this.langid) {
            //             this.items.push(element);
            //         }
            //     }
            // });
            // this.items.forEach(element => {
            //     if (element.name == '') {
            //         var item = this.Records.filter(c => c.id == element.id && c.name != '')[0];
            //         if (item) {
            //             element.name = item.name;
            //         }
            //     }
            //     // element.lastSaveDate = new Date(element.lastSaveDate);
            //     // element.lastSubmitDate = new Date(element.lastSubmitDate)
            // });
            this.items = this.Records;
            this.totalRows = this.Records.length;
            this.gridData = this.getData(this.Records);
        }
    },

    methods: {
        itemsRecordProcess() {
            var r = this.Records;
            r.forEach(item => {
                // item.lastSaveDate = new Date(item.lastSaveDate);
                // item.lastSubmitDate = new Date(item.lastSubmitDate)
            })
            this.items = r;
        },
        onSelectionChange(event) {
            event.dataItem[this.selectedField] = !event.dataItem[this.selectedField];
        },
        handleFilterChange: function (ev) {
            this.filter = ev.filter;

            this.gridData = this.getData(this.items);
        },
        createAppState: function (dataState) {
            this.group = dataState.group;
            this.take = dataState.take;
            this.skip = dataState.skip;
            this.sort = dataState.sort;
            this.filter = dataState.filter;

            this.gridData = this.getData(this.items);
        },
        dataStateChange: function (event) {
            this.createAppState(event.data);
        },
        onFilter(e) {
            let inputValue = this.searchWord;
            this.skip = 0;
            if (inputValue !== '') {
                this.filter = {
                    logic: 'or',
                    filters: [
                        {
                            field: 'name',
                            operator: 'contains',
                            value: inputValue,
                        }
                    ],
                };
            } else this.filter = null;
            this.gridData = this.getData(this.items);
        },
        getData(data) {
            return process(data, {
                take: this.take,
                skip: this.skip,
                group: this.group,
                sort: this.sort,
                filter: this.filter,
            });
        },
        onHeaderSelectionChange(event) {
            let checked = event.event.target.checked;
            const tempData = this.items.map((item) => {
                return { ...item, selected: checked };
            });

            const tempGridData = this.gridData.data.map((item) => {
                return { ...item, selected: checked };
            });
            this.gridData.data = tempGridData;
            this.items = tempData;
        },
        openOrderingPage() {
            this.$root.$emit('bv::toggle::collapse', 'OrderRightpopup');
        },
        onDateRangePickerChange(e, props) {
            const currentFilters = this.filter.filters;

            const isDateRangeFilterApplied =
                currentFilters.filter((el) => el.customOperator == props.field).length !== 0;

            if (isDateRangeFilterApplied) {
                const index = currentFilters.map((e) => e.customOperator).indexOf(props.field);
                currentFilters.splice(index, 1);
            }

            var newFilters = [];
            if (e.value.start) {
                newFilters.push({
                    field: props.field,
                    operator: 'gte',
                    value: e.value.start,
                })
            }
            if (e.value.end) {
                newFilters.push({
                    field: props.field,
                    operator: 'lte',
                    value: e.value.end,
                })
            }

            this.filter.filters.push({
                customOperator: props.field,
                logic: 'and',
                filters: newFilters,
            });
            this.gridData = this.getData(this.items);
        },
        async checkLaunchLimit() {
            if ((this.otherInfo ? this.otherInfo.directory_LaunchedCount : 0) + 1 > (this.otherInfo ? this.otherInfo.directory_TotalQty : 0)) {
                var message = that.$t("lbl_EMPBE_OverActivateCatalogAmount");
                that.alertMsg(message);
            } else {
                this.$router.replace('/productInfoCenter/indexDetail/0');
            }
            // let that = this;
            // var result = await productService
            //     .checkSysAccountPaymentInfo({
            //         CompanyId: this.companyid,
            //         type: "productcatalog",
            //         id: 0,
            //         demodate: "",
            //     })
            //     .then((res) => {
            //         if (res.isSuccessful) {
            //             if (res.data) {
            //                 let data = res.data;
            //                 if (data.launchCount + 1 > (that.otherInfo ? that.otherInfo.directory_TotalQty : 0)) {
            //                     var message = that.$t("lbl_EMPBE_OverActivateCatalogAmount");
            //                     that.alertMsg(message);
            //                 } else {
            //                     that.$router.replace('/productInfoCenter/indexDetail/0');
            //                 }
            //             } else {
            //                 var message = that.$t("lbl_EMPBE_OverActivateCatalogAmount");
            //                 that.alertMsg(message);
            //             }
            //         }
            //     });

        },
        alertMsg(message) {
            this.$swal({
                text: message,
                showCancelButton: false,
            });
        },


    },
};
</script>